import { Store } from "@tldraw/store";
import { createTLSchema } from "@tldraw/tlschema";
import { checkShapesAndAddCore } from "./defaultShapes.mjs";
function createTLStore({ initialData, defaultName = "", ...rest }) {
  const schema = "schema" in rest ? rest.schema : createTLSchema({ shapes: shapesArrayToShapeMap(checkShapesAndAddCore(rest.shapes)) });
  return new Store({
    schema,
    initialData,
    props: {
      defaultName
    }
  });
}
function shapesArrayToShapeMap(shapes) {
  return Object.fromEntries(shapes.map((s) => [s.type, s]));
}
export {
  createTLStore
};
//# sourceMappingURL=createTLStore.mjs.map
